import { types, Instance } from 'mobx-state-tree';

export const SyncModel = types.model('SyncModel', {
    lastSyncSuccess: types.maybe(types.boolean),
    lastSyncDate: types.maybe(types.number),
});

export interface ISyncModel extends Instance<typeof SyncModel> {}
